module.exports = __webpack_public_path__ + "static/img/dialitiko.0818a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/dialitiko.png
// module id = 448
// module chunks = 1